import axios from "axios";

const baseURL = process.env.VUE_APP_API_BASE_URL;
const service = axios.create({
  baseURL,
  timeout: 10000,
  headers: {
    "Content-Type": "application/json",
  },
});

// 请求拦截器：添加token
service.interceptors.request.use(
  (config) => {
    let token = localStorage.getItem("token4VipCenter");
    const expire = localStorage.getItem("token4VipCenter_expire");
    if (token && expire && Date.now() > parseInt(expire, 10)) {
      localStorage.removeItem("token4VipCenter");
      localStorage.removeItem("token4VipCenter_expire");
      token = null;
    }
    
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// 响应拦截器：统一处理错误
service.interceptors.response.use(
  (response) => {
    if (response.data && (response.data.code === 401 || response.data.status === 401)) {
      localStorage.removeItem("token4VipCenter");
      localStorage.removeItem("token4VipCenter_expire");
      if (window.location.pathname === '/' || window.location.pathname === '/vip-center') {
        window.location.reload();
      }
    }
    return response.data;
  },
  (error) => {
    if (error.response && error.response.status === 401) {
      localStorage.removeItem("token4VipCenter");
      localStorage.removeItem("token4VipCenter_expire");
      if (window.location.pathname === '/' || window.location.pathname === '/vip-center') {
        window.location.reload();
      }
    }
    const msg = error.response?.data?.message || "Request failed";
    return Promise.reject(new Error(msg));
  }
);

// 登录（根据邮箱和密码）
export const loginEmailPass = (params) => service.post("/api/auth/loginEmailPass", params);

// 获取VIP信息
export const getVipInfo = (params) => service.post("/api/user/vip/info", params);
// 获取经验记录
export const getExpRecord = (params) => service.post("/api/user/vip/exp/record", params);

// 获取用户信息
export const getUserInfo = (params) => service.post("/api/user/info", params);

export default service;